module.exports = __webpack_public_path__ + "img/support-ticket-active.62510cf0.svg";